export const header = [
    {
        "nombre": "HOME",
        "link": "/"
    },
    {
        "nombre": "ABOUT",
        "link": "/about"
    },
    {
        "nombre": "SERVICES",
        // "link": "/#",
        "submenu": [
            {
                "nombre": "Building Envelope Renewals",
                "link": "/services/building-envelope-renewals"
            },
            {
                "nombre": "Caulking & Sealant Renewal",
                "link": "/services/caulking-sealant-renewal"
            },
            {
                "nombre": "Commercial Exterior Painting",
                "link": "/services/commercial-exterior-painting"
            },
            {
                "nombre": "High-Rise & Mid-Rise Projects",
                "link": "/services/high-rise-mid-rise-projects"
            },
            {
                "nombre": "Commercial Interior Painting",
                "link": "/services/commercial-interior-painting"
            },
            {
                "nombre": "Commercial Snow Removal",
                "link": "/services/commercial-snow-removal"
            },
            {
                "nombre": "General Contracting",
                "link": "/services/general-contracting"
            },
            {
                "nombre": "Concrete Restoration",
                "link": "/services/concrete-restoration"
            },
            {
                "nombre": "Balcony Renewal",
                "link": "/services/balcony-renewal"
            },
            {
                "nombre": "Leak Investigation & Remediation",
                "link": "/services/leak-investigation-and-remediation"
            },
            {
                "nombre": "Windows Cleaning",
                "link": "/services/windows-cleaning"
            },
            {
                "nombre": "Waterproofing Systems",
                "link": "/services/waterproofing-systems"
            }
        ]
    },
    {
        "nombre": "PROJECTS",
        "link": "/projects"
    },
    {
        "nombre": "BLOG",
        "link": "/blog"
    },
    {
        "nombre": "CONTACT",
        "link": "/contact"
    }
];
